import {type} from 'arktype'

import {transformProducts} from '@/models/productModel'

const productSchema = type({
  creation_time: 'string',
  id: 'string',
  image: 'string',
  locale: 'string',
  manufacturer: 'string',
  org_price: 'string',
  price: 'string',
  program: 'string',
  rating: 'string',
  rating_count: 'string',
  retailer: 'string',
  title: 'string',
  url: 'string',
})

const sectionSchema = type({
  'products': productSchema.array(),
  'title': 'string',
  'type': 'string',
  'scraper?': 'string',
  'username?': 'string',
  'subtitle?': 'string',
  'description?': 'string',
})

export const StoreSectionSchema = type({
  'title': 'string',
  'subtitle?': 'string',
  'products': productSchema.array(),
})

export type StoreSection = typeof StoreSectionSchema.infer

export const StoreApiResponseSchema = type({
  display: {
    'banner?': 'string',
    'banner-mobile?': 'string',
    'description': 'string',
    'logo': 'string',
    'name': 'string',
  },
  localization: {
    locale: 'string',
  },
  id: 'string',
  sections: sectionSchema.array(),
}).pipe(response => ({
  ...response,
  sections: response.sections
    .map(section => {
      const {title, subtitle, description, products} = section
      const transformedProducts = transformProducts(products)
      const finalSubtitle = subtitle ?? description

      return {
        title,
        subtitle: finalSubtitle,
        products: transformedProducts,
      }
    })
    .filter(section => section.products.length > 0),
}))

export type StoreApiResponse = typeof StoreApiResponseSchema.infer

export const StoresApiResponseSchema = type({
  'banner': 'string',
  'banner-mobile': 'string',
  'description': 'string',
  'id': 'string',
  'logo': 'string',
  'name': 'string',
}).array()

export type StoresApiResponse = typeof StoresApiResponseSchema.infer
